import { HeroIcons } from "@intrasys/core-ui";

const TABLE_KEYS = {
  LOCATION_LIST: `${import.meta.env.VITE_APP_MODE}-location-list`,
  ARTWORK_LIST: `${import.meta.env.VITE_APP_MODE}-artwork-list`,
  CRATE_LIST: `${import.meta.env.VITE_APP_MODE}-crate-list`,
  COLLECTOR_LIST: `${import.meta.env.VITE_APP_MODE}-collector-list`,
  ARTIST_LIST: `${import.meta.env.VITE_APP_MODE}-artist-list`,
  TRANSACTION_GROUP_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-transactiongroup-list`,
  TRANSACTION_GROUP_ITEM_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-transactiongroupitem-list`,
  TAG_LIST: `${import.meta.env.VITE_APP_MODE}-tag-list`,
  STOCKTAKE_LIST: `${import.meta.env.VITE_APP_MODE}-stocktake_list`,
  ASSETITEM_LIST: `${import.meta.env.VITE_APP_MODE}-assetitem_list`,
  STOCKTAKELINEITEM_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-stocktakelineitem_list`,
  STOCKTAKEEVENT_LIST: `${import.meta.env.VITE_APP_MODE}-stocktakeevent_list`,
  TRANSACTION_LIST: `${import.meta.env.VITE_APP_MODE}-transaction_list`,
  USER_LIST: `${import.meta.env.VITE_APP_MODE}-user_list`,
  ACCOUNTTYPE_LIST: `${import.meta.env.VITE_APP_MODE}-accounttype_list`,
  ROLE_LIST: `${import.meta.env.VITE_APP_MODE}-role_list`,
  CATEGORY_LIST: `${import.meta.env.VITE_APP_MODE}-category_list`,
  ASSETTYPE_LIST: `${import.meta.env.VITE_APP_MODE}-assettype_list`,
  BOATTYPE_LIST: `${import.meta.env.VITE_APP_MODE}-boattype_list`,

  SUPPLIER_LIST: `${import.meta.env.VITE_APP_MODE}-supplier_list`,
  MODEL_LIST: `${import.meta.env.VITE_APP_MODE}-model_list`,
  MANUFACTURER_LIST: `${import.meta.env.VITE_APP_MODE}-manufacturer_list`,
  ASSETISSUE_LIST: `${import.meta.env.VITE_APP_MODE}-assetissue_list`,
  BOATUSAGEREPORT_LIST: `${import.meta.env.VITE_APP_MODE}-boatusagereport_list`,
  TIMEOFUSEREPORT_LIST: `${import.meta.env.VITE_APP_MODE}-timeofusereport_list`,
  VESSEL_USAGE_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-vessel_usage_report_list`,
  VESSEL_STATUS_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-vessel_status_report_list`,
  VESSEL_PERMIT_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-vessel_permit_report_list`,
  VESSEL_SUMMARY_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-vessel_summary_report_list`,
  VESSEL_LOG_BOOK_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-vessel_log_book_report_list`,
  TRANSACTION_LOG_BOOK_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-transaction_log_book_report_list`,
  SERVICENOTES_LIST: `${import.meta.env.VITE_APP_MODE}-servicenotes_list`,
  AUDIT_LOG_LIST: `${import.meta.env.VITE_APP_MODE}-auditlog_list`,
  UNKNOWN_VESSEL_REPORT_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-unknown_vessel_report_list`,
  EMAIL_ALERT_GROUP_LIST: `${
    import.meta.env.VITE_APP_MODE
  }-email_alert_group_list`,
  INVENTORY_REPORT_LIST : `${
    import.meta.env.VITE_APP_MODE
  }-inventory_report_list`,
  ASSET_ITEM_LOCATION_LIST : `${
    import.meta.env.VITE_APP_MODE
  }-asset_item_location_list`,
  ASSET_TYPE_LOCATION_LIST : `${
    import.meta.env.VITE_APP_MODE
  }-asset_type_location_list`,
  TAGGED_USER_LIST : `${
    import.meta.env.VITE_APP_MODE
  }-tagged_user_list`,
  PICKING_TAG_LIST : `${
    import.meta.env.VITE_APP_MODE
  }-picking_tag_list`,
};


const QUERY_KEYS = {
  TRANSACTION_GROUP: `${import.meta.env.VITE_APP_MODE}-transaction-group`,
  PICKLIST: `${import.meta.env.VITE_APP_MODE}-picklist`,
  CRATE: `${import.meta.env.VITE_APP_MODE}-crate`,
  ARTWORK: `${import.meta.env.VITE_APP_MODE}-artwork`,
  STOCKTAKE: `${import.meta.env.VITE_APP_MODE}-stocktake`,
  USER: `${import.meta.env.VITE_APP_MODE}-user`,
  CATEGORY: `${import.meta.env.VITE_APP_MODE}-category`,
  ASSETTYPE: `${import.meta.env.VITE_APP_MODE}-assettype`,
  LOCATION: `${import.meta.env.VITE_APP_MODE}-location`,
  SUPPLIER: `${import.meta.env.VITE_APP_MODE}-supplier`,
  MODEL: `${import.meta.env.VITE_APP_MODE}-model`,
  MANUFACTURER: `${import.meta.env.VITE_APP_MODE}-manufacturer`,
  ASSETISSUE: `${import.meta.env.VITE_APP_MODE}-assetissue`,
  ASSET_ITEM: `${import.meta.env.VITE_APP_MODE}-asset-item`,
  BOATTYPE: `${import.meta.env.VITE_APP_MODE}-boattype`,
  EMAIL_ALERT_GROUP: `${import.meta.env.VITE_APP_MODE}-email-alert-group`,
  ASSET_TYPE_LOCATION: `${import.meta.env.VITE_APP_MODE}-asset-type-location`,
  TRANSACTION_OPERATION: `${import.meta.env.VITE_APP_MODE}-transaction-operation`,
  STOCK_ITEM: `${import.meta.env.VITE_APP_MODE}-stock-item`,
  TRANSACTION_GROUP_STATUS: `${import.meta.env.VITE_APP_MODE}-transaction-group-status`,
  TRANSACTION_GROUP_ITEM: `${import.meta.env.VITE_APP_MODE}-transaction-group-item`,
  MODIFIED_ITEM: `${import.meta.env.VITE_APP_MODE}-modified-item`,
  ITEM_LOGS: `${import.meta.env.VITE_APP_MODE}-item-logs`,
  COMPARE_ITEM: `${import.meta.env.VITE_APP_MODE}-compare-item`,
  VERSIONS: `${import.meta.env.VITE_APP_MODE}-versions`,
  WAREHOUSE_TAG: `${import.meta.env.VITE_APP_MODE}-warehouse-tag`,
  PICKING_TAG: `${import.meta.env.VITE_APP_MODE}-picking-tag`,
  MASS_PICK_WAREHOUSES: `${import.meta.env.VITE_APP_MODE}-mass-pick-warehouses`,
};

const PERMISSION_LIST = [
  {
    name: "Asset Transfer",
    permissions: ["transaction_view", "", "", ""],
  },
  {
    name: "Full Asset",
    permissions: ["assetitem_view", "", "", ""],
  },
  {
    name: "Stock Verification",
    permissions: ["stockTake_view", "stockTake_create", "stockTake_edit", ""],
  },
  {
    name: "Tag Associate",
    permissions: [
      "tagAssociate_view",
      "tagAssociate_create",
      "tagAssociate_edit",
      "",
    ],
  },
  {
    name: "Locations",
    permissions: ["location_view", "location_create", "location_edit", ""],
  },
  {
    name: "Categories",
    permissions: ["category_view", "category_create", "category_edit", ""],
  },
  {
    name: "Asset Types",
    permissions: ["assetType_view", "assetType_create", "assetType_edit", ""],
  },
  {
    name: "Asset Items",
    permissions: ["assetItem_view", "assetItem_create", "assetItem_edit", ""],
  },
  {
    name: "Packing Labels",
    permissions: [
      "packingLabel_view",
      "packingLabel_create",
      "packingLabel_edit",
      "",
    ],
  },
  {
    name: "Cost Centers",
    permissions: [
      "costCenter_view",
      "costCenter_create",
      "costCenter_edit",
      "",
    ],
  },
  {
    name: "Users",
    permissions: ["user_view", "user_create", "user_edit", ""],
  },
  {
    name: "Roles",
    permissions: ["role_view", "role_create", "role_edit", ""],
  },
];
const OPERATION_LIST = [
  { name: "All Types", icon: "EllipsisHorizontalCircleIcon" },
  { name: "Maintenance", icon: "WrenchIcon" },
  { name: "Out to sea", icon: "LifebuoyIcon" },
  { name: "Warehouse", icon: "HomeModernIcon" },
  { name: "Service", icon: "WrenchScrewdriverIcon" },
  { name: "Loan", icon: "ArrowTopRightOnSquareIcon" },
  { name: "Inspection", icon: "MagnifyingGlassCircleIcon" },
  { name: "Decommission", icon: "LinkIcon" },
  { name: "Unknown", icon: "XCircleIcon" },
  { name: "Others", icon: "EllipsisHorizontalCircleIcon" },
] as { name: string; icon: HeroIcons }[];

const HERO_ICONS = [
  "AcademicCapIcon",
  "AdjustmentsHorizontalIcon",
  "AdjustmentsVerticalIcon",
  "ArchiveBoxArrowDownIcon",
  "ArchiveBoxXMarkIcon",
  "ArchiveBoxIcon",
  "ArrowDownCircleIcon",
  "ArrowDownLeftIcon",
  "ArrowDownOnSquareStackIcon",
  "ArrowDownOnSquareIcon",
  "ArrowDownRightIcon",
  "ArrowDownTrayIcon",
  "ArrowDownIcon",
  "ArrowLeftCircleIcon",
  "ArrowLeftOnRectangleIcon",
  "ArrowLeftIcon",
  "ArrowLongDownIcon",
  "ArrowLongLeftIcon",
  "ArrowLongRightIcon",
  "ArrowLongUpIcon",
  "ArrowPathRoundedSquareIcon",
  "ArrowPathIcon",
  "ArrowRightCircleIcon",
  "ArrowRightOnRectangleIcon",
  "ArrowRightIcon",
  "ArrowSmallDownIcon",
  "ArrowSmallLeftIcon",
  "ArrowSmallRightIcon",
  "ArrowSmallUpIcon",
  "ArrowTopRightOnSquareIcon",
  "ArrowTrendingDownIcon",
  "ArrowTrendingUpIcon",
  "ArrowUpCircleIcon",
  "ArrowUpLeftIcon",
  "ArrowUpOnSquareStackIcon",
  "ArrowUpOnSquareIcon",
  "ArrowUpRightIcon",
  "ArrowUpTrayIcon",
  "ArrowUpIcon",
  "ArrowUturnDownIcon",
  "ArrowUturnLeftIcon",
  "ArrowUturnRightIcon",
  "ArrowUturnUpIcon",
  "ArrowsPointingInIcon",
  "ArrowsPointingOutIcon",
  "ArrowsRightLeftIcon",
  "ArrowsUpDownIcon",
  "AtSymbolIcon",
  "BackspaceIcon",
  "BackwardIcon",
  "BanknotesIcon",
  "Bars2Icon",
  "Bars3BottomLeftIcon",
  "Bars3BottomRightIcon",
  "Bars3CenterLeftIcon",
  "Bars3Icon",
  "Bars4Icon",
  "BarsArrowDownIcon",
  "BarsArrowUpIcon",
  "Battery0Icon",
  "Battery100Icon",
  "Battery50Icon",
  "BeakerIcon",
  "BellAlertIcon",
  "BellSlashIcon",
  "BellSnoozeIcon",
  "BellIcon",
  "BoltSlashIcon",
  "BoltIcon",
  "BookOpenIcon",
  "BookmarkSlashIcon",
  "BookmarkSquareIcon",
  "BookmarkIcon",
  "BriefcaseIcon",
  "BugAntIcon",
  "BuildingLibraryIcon",
  "BuildingOffice2Icon",
  "BuildingOfficeIcon",
  "BuildingStorefrontIcon",
  "CakeIcon",
  "CalculatorIcon",
  "CalendarDaysIcon",
  "CalendarIcon",
  "CameraIcon",
  "ChartBarSquareIcon",
  "ChartBarIcon",
  "ChartPieIcon",
  "ChatBubbleBottomCenterTextIcon",
  "ChatBubbleBottomCenterIcon",
  "ChatBubbleLeftEllipsisIcon",
  "ChatBubbleLeftRightIcon",
  "ChatBubbleLeftIcon",
  "ChatBubbleOvalLeftEllipsisIcon",
  "ChatBubbleOvalLeftIcon",
  "CheckBadgeIcon",
  "CheckCircleIcon",
  "CheckIcon",
  "ChevronDoubleDownIcon",
  "ChevronDoubleLeftIcon",
  "ChevronDoubleRightIcon",
  "ChevronDoubleUpIcon",
  "ChevronDownIcon",
  "ChevronLeftIcon",
  "ChevronRightIcon",
  "ChevronUpDownIcon",
  "ChevronUpIcon",
  "CircleStackIcon",
  "ClipboardDocumentCheckIcon",
  "ClipboardDocumentListIcon",
  "ClipboardDocumentIcon",
  "ClipboardIcon",
  "ClockIcon",
  "CloudArrowDownIcon",
  "CloudArrowUpIcon",
  "CloudIcon",
  "CodeBracketSquareIcon",
  "CodeBracketIcon",
  "Cog6ToothIcon",
  "Cog8ToothIcon",
  "CogIcon",
  "CommandLineIcon",
  "ComputerDesktopIcon",
  "CpuChipIcon",
  "CreditCardIcon",
  "CubeTransparentIcon",
  "CubeIcon",
  "CurrencyBangladeshiIcon",
  "CurrencyDollarIcon",
  "CurrencyEuroIcon",
  "CurrencyPoundIcon",
  "CurrencyRupeeIcon",
  "CurrencyYenIcon",
  "CursorArrowRaysIcon",
  "CursorArrowRippleIcon",
  "DevicePhoneMobileIcon",
  "DeviceTabletIcon",
  "DocumentArrowDownIcon",
  "DocumentArrowUpIcon",
  "DocumentChartBarIcon",
  "DocumentCheckIcon",
  "DocumentDuplicateIcon",
  "DocumentMagnifyingGlassIcon",
  "DocumentMinusIcon",
  "DocumentPlusIcon",
  "DocumentTextIcon",
  "DocumentIcon",
  "EllipsisHorizontalCircleIcon",
  "EllipsisHorizontalIcon",
  "EllipsisVerticalIcon",
  "EnvelopeOpenIcon",
  "EnvelopeIcon",
  "ExclamationCircleIcon",
  "ExclamationTriangleIcon",
  "EyeDropperIcon",
  "EyeSlashIcon",
  "EyeIcon",
  "FaceFrownIcon",
  "FaceSmileIcon",
  "FilmIcon",
  "FingerPrintIcon",
  "FireIcon",
  "FlagIcon",
  "FolderArrowDownIcon",
  "FolderMinusIcon",
  "FolderOpenIcon",
  "FolderPlusIcon",
  "FolderIcon",
  "ForwardIcon",
  "FunnelIcon",
  "GifIcon",
  "GiftTopIcon",
  "GiftIcon",
  "GlobeAltIcon",
  "GlobeAmericasIcon",
  "GlobeAsiaAustraliaIcon",
  "GlobeEuropeAfricaIcon",
  "HandRaisedIcon",
  "HandThumbDownIcon",
  "HandThumbUpIcon",
  "HashtagIcon",
  "HeartIcon",
  "HomeModernIcon",
  "HomeIcon",
  "IdentificationIcon",
  "InboxArrowDownIcon",
  "InboxStackIcon",
  "InboxIcon",
  "InformationCircleIcon",
  "KeyIcon",
  "LanguageIcon",
  "LifebuoyIcon",
  "LightBulbIcon",
  "LinkIcon",
  "ListBulletIcon",
  "LockClosedIcon",
  "LockOpenIcon",
  "MagnifyingGlassCircleIcon",
  "MagnifyingGlassMinusIcon",
  "MagnifyingGlassPlusIcon",
  "MagnifyingGlassIcon",
  "MapPinIcon",
  "MapIcon",
  "MegaphoneIcon",
  "MicrophoneIcon",
  "MinusCircleIcon",
  "MinusSmallIcon",
  "MinusIcon",
  "MoonIcon",
  "MusicalNoteIcon",
  "NewspaperIcon",
  "NoSymbolIcon",
  "PaintBrushIcon",
  "PaperAirplaneIcon",
  "PaperClipIcon",
  "PauseCircleIcon",
  "PauseIcon",
  "PencilSquareIcon",
  "PencilIcon",
  "PhoneArrowDownLeftIcon",
  "PhoneArrowUpRightIcon",
  "PhoneXMarkIcon",
  "PhoneIcon",
  "PhotoIcon",
  "PlayCircleIcon",
  "PlayPauseIcon",
  "PlayIcon",
  "PlusCircleIcon",
  "PlusSmallIcon",
  "PlusIcon",
  "PowerIcon",
  "PresentationChartBarIcon",
  "PresentationChartLineIcon",
  "PrinterIcon",
  "PuzzlePieceIcon",
  "QrCodeIcon",
  "QuestionMarkCircleIcon",
  "QueueListIcon",
  "RadioIcon",
  "ReceiptPercentIcon",
  "ReceiptRefundIcon",
  "RectangleGroupIcon",
  "RectangleStackIcon",
  "RocketLaunchIcon",
  "RssIcon",
  "ScaleIcon",
  "ScissorsIcon",
  "ServerStackIcon",
  "ServerIcon",
  "ShareIcon",
  "ShieldCheckIcon",
  "ShieldExclamationIcon",
  "ShoppingBagIcon",
  "ShoppingCartIcon",
  "SignalSlashIcon",
  "SignalIcon",
  "SparklesIcon",
  "SpeakerWaveIcon",
  "SpeakerXMarkIcon",
  "Square2StackIcon",
  "Square3Stack3DIcon",
  "Squares2X2Icon",
  "SquaresPlusIcon",
  "StarIcon",
  "StopCircleIcon",
  "StopIcon",
  "SunIcon",
  "SwatchIcon",
  "TableCellsIcon",
  "TagIcon",
  "TicketIcon",
  "TrashIcon",
  "TrophyIcon",
  "TruckIcon",
  "TvIcon",
  "UserCircleIcon",
  "UserGroupIcon",
  "UserMinusIcon",
  "UserPlusIcon",
  "UserIcon",
  "UsersIcon",
  "VariableIcon",
  "VideoCameraSlashIcon",
  "VideoCameraIcon",
  "ViewColumnsIcon",
  "ViewfinderCircleIcon",
  "WalletIcon",
  "WifiIcon",
  "WindowIcon",
  "WrenchScrewdriverIcon",
  "WrenchIcon",
  "XCircleIcon",
  "XMarkIcon",
] as const;

export { TABLE_KEYS, QUERY_KEYS, PERMISSION_LIST, OPERATION_LIST, HERO_ICONS };
